{
  "satellite": "GOES-19",
  "sector": "nsa",
  "lon0": -75.0,
  "h": 35786023,
  "sweep": "x",
  "ellps": "GRS80",
  "xMin": -0.040572,
  "xMax": 0.161028,
  "yMin": -0.06048,
  "yMax": 0.06048,
  "calibrated": true,
  "referenceProduct": "GEOCOLOR",
  "pixelSizeRad": 2.8e-05,
  "gridOrigin": {
    "col": 3975,
    "row": 3264,
    "grid": "ABI 1 km (10848x10848), bordas em ±0.151872 rad"
  },
  "rmsPx7200": 1.34,
  "rmsKm7200": 1.39,
  "originUncertaintyPx7200": [
    0.054,
    0.044
  ],
  "footerFraction": 0.01019,
  "logoBox": {
    "x0": 0.0017,
    "y0": 0.9086,
    "x1": 0.0503,
    "y1": 0.9896
  },
  "decorationsBySize": {
    "7200": {
      "footerPx": 44,
      "footerFraction": 0.01019,
      "logoPx": [
        12,
        3925,
        362,
        4275
      ],
      "logoBox": [
        0.0017,
        0.9086,
        0.0503,
        0.9896
      ]
    },
    "3600": {
      "footerPx": 38,
      "footerFraction": 0.01759,
      "logoPx": [
        12,
        1971,
        162,
        2121
      ],
      "logoBox": [
        0.0033,
        0.9125,
        0.045,
        0.9819
      ]
    },
    "1800": {
      "footerPx": 28,
      "footerFraction": 0.02593,
      "logoPx": [
        12,
        971,
        92,
        1051
      ],
      "logoBox": [
        0.0067,
        0.8991,
        0.0511,
        0.9731
      ]
    },
    "900": {
      "footerPx": 18,
      "footerFraction": 0.03333,
      "logoPx": [
        12,
        462,
        72,
        521
      ],
      "logoBox": [
        0.0133,
        0.8556,
        0.08,
        0.9648
      ]
    },
    "450": {
      "footerPx": 14,
      "footerFraction": 0.05185,
      "logoPx": [
        11,
        243,
        47,
        255
      ],
      "logoBox": [
        0.0244,
        0.9,
        0.1044,
        0.9444
      ]
    }
  },
  "gridOriginsFormula": "[col, row] = canto superior esquerdo da imagem na grade de 1 km (pode ser fracionário); xMin = -0.151872 + col*pixelSizeRad; yMax = 0.151872 - row*pixelSizeRad; xMax = xMin + 7200*pixelSizeRad; yMin = yMax - 4320*pixelSizeRad (vale para qualquer largura)",
  "gridOrigins": {
    "ir2km": {
      "products": [
        "04",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "AirMass",
        "Sandwich",
        "FireTemperature",
        "DayNightCloudMicroCombo",
        "Dust"
      ],
      "7200": [
        3974,
        3264
      ],
      "3600": [
        3975.47,
        3265.48
      ],
      "1800": [
        3976.43,
        3266.49
      ],
      "900": [
        3978.22,
        3268.5
      ],
      "450": [
        3982.37,
        3272.64
      ]
    },
    "vis1km": {
      "products": [
        "01",
        "03",
        "05"
      ],
      "7200": [
        3976,
        3265
      ],
      "3600": [
        3976.48,
        3265.48
      ],
      "1800": [
        3977.42,
        3266.47
      ],
      "900": [
        3979.22,
        3268.54
      ],
      "450": [
        3983.62,
        3272.77
      ]
    },
    "vis05km": {
      "products": [
        "02"
      ],
      "7200": [
        3975.5,
        3264.5
      ],
      "3600": [
        3975.99,
        3264.99
      ],
      "1800": [
        3976.95,
        3265.94
      ],
      "900": [
        3978.68,
        3268.02
      ],
      "450": [
        3982.78,
        3272.16
      ]
    },
    "geocolor": {
      "products": [
        "GEOCOLOR"
      ],
      "7200": [
        3975,
        3264
      ],
      "3600": [
        3976.46,
        3265.48
      ],
      "1800": [
        3977.37,
        3266.49
      ],
      "900": [
        3979.03,
        3268.59
      ],
      "450": [
        3983.4,
        3272.72
      ]
    }
  },
  "method": "Ajuste robusto ponto-a-linha (sub-pixel) das fronteiras gravadas pela NOAA contra Natural Earth 10m (costa, fronteiras, estados do Brasil) projetado em +proj=geos lon0=-75.0 sweep=x; passo fixo de 28 µrad; origem inteira confirmada pela escada do limbo da Terra na banda 13. scripts/georef/calibrate.py",
  "calibrationFrame": "20262580010",
  "calibratedAt": "2026-09-15T02:36:30+00:00"
}
